import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Briefcase, DollarSign } from 'lucide-react';
import './CareersPage.css';

const positions = [
  {
    title: 'React Developer',
    value: 'react-developer',
    department: 'Engineering',
    location: 'Remote / Hyderabad',
    type: 'Full-Time',
    experience: 'Fresher / 2+ years Experience',
    description: 'We\'re looking for a React developer to lead frontend development for our enterprise clients.'
  },
  {
    title: 'AI/ML Engineer',
    value: 'ai-ml-engineer',
    department: 'AI & Data',
    location: 'Remote / Hyderabad',
    type: 'Full-Time',
    experience: 'Fresher / 2+ years Experience',
    description: 'Join our AI team to build cutting-edge machine learning solutions for healthcare and fintech.'
  },
  {
    title: 'UX/UI Designer',
    value: 'ux-ui-designer',
    department: 'Design',
    location: 'Remote / Hyderabad',
    type: 'Full-time, Part-Time',
    experience: 'Fresher / 2+ years Experience',
    description: 'Create beautiful, intuitive interfaces for web and mobile applications.'
  },
  {
    title: 'DevOps Engineer',
    value: 'devops-engineer',
    department: 'Cloud & Infrastructure',
    location: 'Remote / Hyderabad',
    type: 'Full-time, Part-Time',
    experience: 'Fresher / 2+ years Experience',
    description: 'Help us build and maintain scalable cloud infrastructure for our growing client base.'
  }
];

const benefits = [
  'Competitive Salary',
  'Remote Work Options',
  'Professional Development',
  'Flexible Hours',
  'Paid Time Off',
];

const CareersPage = () => {
  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="container">
          <h1>Join Our <span className="blue-text">Team</span></h1>
          <p>Build the future of technology with us</p>
        </div>
      </section>

      <section className="culture-section section">
        <div className="container">
          <h2 className="section-title">Our <span className="blue-text">Culture</span></h2>
          <div className="culture-grid">
            <div className="culture-card">
              <h3>Innovation First</h3>
              <p>We encourage creative thinking and provide resources to explore new ideas.</p>
            </div>
            <div className="culture-card">
              <h3>Work-Life Balance</h3>
              <p>Flexible hours and remote options to help you do your best work.</p>
            </div>
            <div className="culture-card">
              <h3>Continuous Learning</h3>
              <p>Learning stipends, conferences, and internal training programs.</p>
            </div>
            <div className="culture-card">
              <h3>Diverse & Inclusive</h3>
              <p>We celebrate diversity and foster an inclusive environment for all.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Benefits & <span className="blue-text">Perks</span></h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item">
                <span className="benefit-bullet">✦</span>
                {benefit}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="open-positions section">
        <div className="container">
          <h2 className="section-title">Open <span className="blue-text">Positions</span></h2>
          <div className="positions-list">
            {positions.map((position, index) => (
              <div key={index} className="position-card">
                <div className="position-header">
                  <h3>{position.title}</h3>
                  <span className="department">{position.department}</span>
                </div>
                <div className="position-details">
                  <span><MapPin size={16} /> {position.location}</span>
                  <span><Briefcase size={16} /> {position.type}</span>
                  <span><Clock size={16} /> {position.experience}</span>
                  <span><DollarSign size={16} /> {position.salary}</span>
                </div>
                <p className="position-description">{position.description}</p>
                <Link 
                  to="/careers/apply" 
                  state={{ role: position.value }} 
                  className="btn btn-primary apply-btn"
                >
                  Apply Now
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;